import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKRapport,
  IGKVisualiseringAvLuftstroemResultater,
} from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const VisualiseringAvLuftstroem: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKVisualiseringAvLuftstroemResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Visualisering av luftstrøm</Title>
        <div className="w-50 mt-0">
          <div>
            <McTextAreaNew
              label="Beskrivelse av luftstrøm:"
              value={data.inndata.beskrivelseAvLuftstroem}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.visualiseringAvLuftstroem.inndata.beskrivelseAvLuftstroem",
                  e.target.value,
                )
              }
            />
          </div>
          <div>
            <div className="d-flex flex-column mt-2">
                            <Radio
                checked={data.inndata.godkjent === true}
                onChange={() => onUpdateEditData("testResultater.visualiseringAvLuftstroem.inndata.godkjent", true)}
                label="Godkjent"
              />
                            <Radio
                checked={data.inndata.godkjent === false}
                onChange={() => onUpdateEditData("testResultater.visualiseringAvLuftstroem.inndata.godkjent", false)}
                label="Ikke godkjent"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer docxImageTag="visualiseringAvLuftstroem" title="Bilde av luftstrøm" />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.visualiseringAvLuftstroem.inndata.kommentar", e.target.value)
              }
            />
          </div>
        </div>
      </Stack>
    </Paper>
  );
};
export default VisualiseringAvLuftstroem;